import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { OasisIcon } from '../CustomIcons/OasisIcon'

interface LogotypeProps {
  showText: boolean
}

export const HomePageLink: FC<LogotypeProps> = ({ showText }) => {
  const { t } = useTranslation()

  return (
    <RouterLink to="/" aria-label={t('home.link')}>
      <Logotype showText={showText} />
    </RouterLink>
  )
}

export const Logotype: FC<LogotypeProps> = ({ showText }) => {
  return (
    <div className="flex items-center gap-2 text-[#0A3A84]">
      <OasisIcon className={showText ? 'h-7 w-7 sm:h-8 sm:w-8' : undefined} />
      {showText && (
        <span className="font-extrabold text-xl tracking-tight whitespace-nowrap">
          {/* Keep literal "OXN Explorer" for Dockerfile branding assert */}
          OXN Explorer
        </span>
      )}
    </div>
  )
}
